import { createAction } from '@reduxjs/toolkit';
import get from 'lodash/get';
import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from "../../utils/redux/getConstantsByFeatureName";
import getActionCreators from "../../utils/redux/getActionCreators";
import getActionHandlers from "../../utils/redux/getActionHandlers";
import { initialState } from "../../utils/redux/commonActionHandlers";
import getSelectorByFeatureName from "../../utils/redux/getSelectorByFeatureName";

export const constants = {
  ...getConstantsByFeatureName("OWNER_RETENTION_RATE"),
  ASSIGN_RR_ROLE: "@OWNER_RETENTION_RATE/ASSIGN_RR_ROLE",
  UNASSIGN_RR_ROLE: "@OWNER_RETENTION_RATE/UNASSIGN_RR_ROLE",
  LOAD_RR_DATA: "@OWNER_RETENTION_RATE/LOAD_RR_DATA",
  SET_RR_DATA: "@OWNER_RETENTION_RATE/SET_RR_DATA",
  CALCULATE_CUSTOM_RANGE: "@OWNER_RETENTION_RATE/CALCULATE_CUSTOM_RANGE",
  SET_CUSTOM_RANGE_RR: "@OWNER_RETENTION_RATE/SET_CUSTOM_RANGE_RR",
  DOWNLOAD_REPORT: "@OWNER_RETENTION_RATE/DOWNLOAD_REPORT",
  SET_REPORT_DOWNLOADING: "@OWNER_RETENTION_RATE/SET_REPORT_DOWNLOADING",
};

export const actions = {
  ...getActionCreators(constants),
  assignRRRole: createAction(constants.ASSIGN_RR_ROLE),
  unassignRRRole: createAction(constants.UNASSIGN_RR_ROLE),
  loadRRData: createAction(constants.LOAD_RR_DATA),
  setRRData: createAction(constants.SET_RR_DATA),
  calculateCustomRangeRR: createAction(constants.CALCULATE_CUSTOM_RANGE),
  setCustomRangeRR: createAction(constants.SET_CUSTOM_RANGE_RR),
  downloadReport: createAction(constants.DOWNLOAD_REPORT),
  setReportDownloading: createAction(constants.SET_REPORT_DOWNLOADING),
};

const customActionHandlers = {
  [constants.SET_RR_DATA]: (state, action) => ({
    ...state,
    rrData: action.payload,
  }),
  [constants.SET_CUSTOM_RANGE_RR]: (state, action) => ({
    ...state,
    rangeRRData: action.payload,
  }),
  [constants.SET_REPORT_DOWNLOADING]: (state, action) => ({
    ...state,
    isReportDownloading: !!action.payload,
  }),
};

export const actionHandlers = {
  ...getActionHandlers(constants),
  ...customActionHandlers,
};

export const selector = (state) => ({
  ...getSelectorByFeatureName("ownerDetailsRetentionRate")(state),
  rrData: state.ownerDetailsRetentionRate.rrData,
  rangeRRData: state.ownerDetailsRetentionRate.rangeRRData,
  isReportDownloading: state.ownerDetailsRetentionRate.isReportDownloading,
  // The RR source report (full pool history + removal reasons) is
  // admin/superuser-only; the BE enforces the same on the endpoint.
  canDownloadReport: ['admin', 'superuser'].includes(get(state, 'auth.data.role')),
});

export const reducer = buildReducer({
  ...initialState,
  rrData: null,
  rangeRRData: null,
  isReportDownloading: false,
}, actionHandlers);
